module.exports = __webpack_public_path__ + "static/img/haihang.87e0f464.png";